import React from 'react';

interface AdSkeletonProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

export const AdSkeleton: React.FC<AdSkeletonProps> = ({
  width = '100%',
  height = '100%',
  className,
}) => {
  return (
    <div
      className={className}
      style={{
        width,
        height,
        backgroundColor: '#2C2C2C',
        animation: 'pulse 1.5s infinite ease-in-out',
        borderRadius: '8px',
      }}
    >
      <style jsx>{`
        @keyframes pulse {
          0% {
            opacity: 0.6;
          }
          50% {
            opacity: 0.8;
          }
          100% {
            opacity: 0.6;
          }
        }
      `}</style>
    </div>
  );
};
